import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import { EMPLOYEES_LIST_PERMISSIONS, EMPLOYEES_MAIN_ROUTE_NAME } from '@modules/employees/constants';
import {
  EMPLOYEES_CREATE_ROUTE_NAME,
  TRANSLATION_GROUP_EMPLOYEES_CREATE,
} from '@modules/employees/submodules/create/constants';
import { getTranslationKeys } from '@modules/employees/submodules/create/translations';

export class EmployeesCreateModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(EMPLOYEES_MAIN_ROUTE_NAME, {
      name: EMPLOYEES_CREATE_ROUTE_NAME,
      path: 'create',
      component: () => import('@modules/employees/submodules/create/pages/EmployeeCreatePage/EmployeeCreatePage.vue'),
      permission: EMPLOYEES_LIST_PERMISSIONS.CREATE,
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_EMPLOYEES_CREATE, getTranslationKeys);
  }
}
